var _excluded = ["event"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultOptions = {
  debug: false,
  logger: console,
  dispatchEvent: true,
  eventPrefix: true
};
export var StimulusUse = function StimulusUse(controller) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, StimulusUse);

  var _a, _b, _c;

  this.log = function (functionName, args) {
    if (!_this.debug) return;

    _this.logger.groupCollapsed("%c".concat(_this.controller.identifier, " %c#").concat(functionName), 'color: #3B82F6', 'color: unset');

    _this.logger.log(_objectSpread({
      controllerId: _this.controllerId
    }, args));

    _this.logger.groupEnd();
  };

  this.dispatch = function (eventName) {
    var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_this.dispatchEvent) {
      var event = details.event,
          eventDetails = _objectWithoutProperties(details, _excluded);

      var customEvent = _this.extendedEvent(eventName, event || null, eventDetails);

      _this.targetElement.dispatchEvent(customEvent);

      _this.log('dispatchEvent', _objectSpread({
        eventName: customEvent.type
      }, eventDetails));
    }
  };

  this.call = function (methodName) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = _this.controller[methodName];

    if (typeof method == 'function') {
      return method.call(_this.controller, args);
    }
  };

  this.extendedEvent = function (name, event, detail) {
    var _ref = event || {
      bubbles: true,
      cancelable: true,
      composed: true
    },
        bubbles = _ref.bubbles,
        cancelable = _ref.cancelable,
        composed = _ref.composed;

    if (event) {
      Object.assign(detail, {
        originalEvent: event
      });
    }

    var customEvent = new CustomEvent(_this.composeEventName(name), {
      bubbles: bubbles,
      cancelable: cancelable,
      composed: composed,
      detail: detail
    });
    return customEvent;
  };

  this.composeEventName = function (name) {
    var composedName = name;

    if (_this.eventPrefix === true) {
      composedName = "".concat(_this.controller.identifier, ":").concat(name);
    } else if (typeof _this.eventPrefix === 'string') {
      composedName = "".concat(_this.eventPrefix, ":").concat(name);
    }

    return composedName;
  };

  this.debug = (_b = (_a = options === null || options === void 0 ? void 0 : options.debug) !== null && _a !== void 0 ? _a : controller.application.stimulusUseDebug) !== null && _b !== void 0 ? _b : defaultOptions.debug;
  this.logger = (_c = options === null || options === void 0 ? void 0 : options.logger) !== null && _c !== void 0 ? _c : defaultOptions.logger;
  this.controller = controller;
  this.controllerId = controller.element.id || controller.element.dataset.id;
  this.targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;

  var _Object$assign = Object.assign({}, defaultOptions, options),
      dispatchEvent = _Object$assign.dispatchEvent,
      eventPrefix = _Object$assign.eventPrefix;

  Object.assign(this, {
    dispatchEvent: dispatchEvent,
    eventPrefix: eventPrefix
  }); // make copies of lifecycle functions

  this.controllerInitialize = controller.initialize.bind(controller);
  this.controllerConnect = controller.connect.bind(controller);
  this.controllerDisconnect = controller.disconnect.bind(controller);
};